import { Environment } from './environment.interface';
import { baseEnvironment } from './environment.base';

/**
 * Demo Environment Configuration
 *
 * Configuration for demo environment.
 * Uses demo API endpoints and services.
 */

export const environment: Environment = {
  ...baseEnvironment,
  production: false,
  environmentName: 'demo',
  apiEndpoints: {
    gatewayBaseUrl: 'https://demo.api.smartlinks-np.dev'
  },
} as Environment;
